<template>
  <div class="cover">
    <div @click="openModal">
      <slot></slot>
    </div>

    <Modal :is-modal-active="isModalVisible || active" @close="closeModal">
      <template #title>
        {{ $t("confirm_email.title") }}
      </template>

      <div v-if="user.email_verified">
        <p class="info">{{ $t("confirm_email.success") }}</p>
        <div class="buttons">
          <RippleButton class="button" type="prime" @click="acceptCookies">
            {{ $t("close") }}
          </RippleButton>
        </div>
      </div>

      <div v-else>
        <CustomInput
          v-model="code"
          class-name="custom-input"
          type="test"
          placeholder="Code"
          input-type="text"
        />
        <p class="policy">Check your email for a code.</p>
        <div class="buttons">
          <RippleButton class="button" type="prime" @click="submit">
            confirm email
          </RippleButton>
          <RippleButton
            :disabled="isActual"
            class="button"
            type="prime"
            @click="sendCode"
          >
            {{ isActual ? `resend code in ${time}` : "resend code" }}
          </RippleButton>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance, onUnmounted } from "vue";
import RippleButton from "../common/form/Button.vue";
import Modal from "./Modal.vue";
import CustomInput from "../common/form/Input.vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import moment from "moment";

const { t } = useI18n();
const { proxy } = getCurrentInstance();
const store = useStore();

const code = ref("");
const isLoading = ref(false);
const isModalVisible = ref(false);
const currentTime = ref(moment());
let timerInterval = null;

const user = computed(() => store.getters.gerUser);
const isActual = computed(() => {
  if (!user.value?.endCodeDate) return false;

  const endDate = new Date(user.value.endCodeDate);
  const now = new Date();

  return endDate > now;
});

const time = computed(() => {
  return moment(user.value.endCodeDate).from(currentTime.value, true);
});

function sendCode() {
  if (isLoading.value) return;

  isLoading.value = true;
  store
    .dispatch("sendCode")
    .then((res) => {
      console.log(res);
      proxy.$notify({
        type: "success",
        title: `✔️ ${t("Success")}`,
        text: t("confirm_email.send_success"),
      });
    })
    .catch((text) => {
      console.log(text);
      proxy.$notify({
        type: "error",
        title: `❌ ${t("Error")}`,
        text,
      });
    })
    .finally(() => {
      isLoading.value = false;
    });
}

function submit() {
  if (isLoading.value) return;

  isLoading.value = true;
  store
    .dispatch("checkCode", code.value)
    .then((res) => {
      proxy.$notify({
        type: "success",
        title: `✔️ ${t("Success")}`,
        text: t("confirm_email.success"),
      });
    })
    .catch((text) => {
      proxy.$notify({
        type: "error",
        title: `❌ ${t("Error")}`,
        text,
      });
    })
    .finally(() => {
      isLoading.value = false;
    });
}

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});

function openModal() {
  if (!isActual.value && user.value && !user.value.email_verified) {
    sendCode();
  }
  isModalVisible.value = true;
}

function closeModal() {
  isModalVisible.value = false;
}

onMounted(() => {
  timerInterval = setInterval(() => {
    currentTime.value = moment();
  }, 10000);
});

onUnmounted(() => {
  if (timerInterval) {
    clearInterval(timerInterval);
  }
});
</script>
<style lang="scss" scoped>
a {
  color: var(--brand-color);
  text-decoration: underline;
}
.cover {
  overflow-y: auto;
  overflow-x: hidden;
}
.info {
  padding-left: 40px;
}
.policy {
  margin-bottom: 15px;
}
.button {
  width: 250px;
  height: 60px;
}
.buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
